/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import { graphql } from 'react-apollo'
import gql from 'graphql-tag'


import { Spinner } from '../'

class PayrollCycleFrequency extends React.PureComponent {
  state = {
    dataFetchAttempts: 0
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.data.error && this.props.data.error && prevState.dataFetchAttempts === 0) {
      this.setState(prevState => ({ dataFetchAttempts: prevState.dataFetchAttempts + 1 }))
    }
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner type='brand' />
    }

    if (this.props.data.error) {
      if (this.state.dataFetchAttempts > 0) {
        this.props.data.refetch()
      }

      return null
    }

    return (
      <span>
        {this.props.data.payrollcycle.cycle.toLowerCase()}
      </span>
    )
  }
}

PayrollCycleFrequency.propTypes = {
  data: PropTypes.object.isRequired
}

const getPayrollCycle = gql`
  query ($id: ID!) {
    payrollcycle(id: $id) {
      id
      cycle
    }
  }
`

const withData = graphql(getPayrollCycle, {
  options: ({ payrollCycle }) => ({
    variables: {
      id: payrollCycle
    }
  })
})

export default withData(PayrollCycleFrequency)



// WEBPACK FOOTER //
// ./src/components/payroll-cycle-frequency/index.js